module.exports = __webpack_public_path__ + "static/img/rightTopShareImg.fb4a65b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/rightTopShareImg.png
// module id = x93D
// module chunks = 272